import React from 'react';
import { Col } from 'antd';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown/with-html';
import { withResponsive } from '$util/theme';
import { Button, DesignType } from '@/components/atoms/Button';
import {
  BackgroundContainer,
  WidgetContainer,
  ShapeOverlay,
  StyledRow,
  StyledTitle,
  BgImage,
  BgVideo,
  VideoWrapper,
  StyledVrmLookup,
  LimitWidthOverlay,
} from './styled';

const ResponsiveShapeOverlay = withResponsive(ShapeOverlay);
const ResponsiveBgImage = withResponsive(BgImage);
const ResponsiveVideoWrapper = withResponsive(VideoWrapper);

export interface IParams {
  readonly title?: string;
  readonly bodyText?: string;
  readonly useVideo?: string;
  readonly ctaButtonText?: string;
  readonly ctaButtonUrl?: string;
  readonly bgImageUrl?: string;
  readonly vimeoId?: string;
  readonly campaignId?: string;
  readonly limitWidth?: string;
  readonly bgColour?: string;
  readonly itmWidget?: string;
  readonly itmArticle?: string;
  readonly itmWo?: string;
  readonly sku?: string;
}

export interface IProps {
  readonly params: IParams;
  readonly data?: {
    vrmLookup?: boolean;
  };
}

export default function BannerWithCta({ params, data }: IProps) {
  const {
    title = '',
    bodyText,
    useVideo,
    ctaButtonText = '',
    ctaButtonUrl,
    bgImageUrl,
    vimeoId,
    campaignId,
    limitWidth,
    bgColour,
    itmWidget,
    itmArticle,
    itmWo,
    sku,
  } = params;

  const vrmLookup = data?.vrmLookup;

  return (
    <BackgroundContainer
      className={classNames(limitWidth === 'true' && 'rounded', 'BannerWithCta')}
      style={{ backgroundColor: bgColour }}
    >
      {limitWidth !== 'true' && <ResponsiveShapeOverlay displayFrom="md" />}
      <WidgetContainer>
        <StyledRow>
          <Col xs={24} md={limitWidth === 'true' ? 24 : 14}>
            <StyledTitle>
              <ReactMarkdown
                source={title}
                renderers={{
                  // eslint-disable-next-line
                  paragraph: (pProps) => <React.Fragment {...pProps} />,
                }}
              />
            </StyledTitle>
            {bodyText && <ReactMarkdown source={decodeURIComponent(bodyText)} />}
            {vrmLookup ? (
              <StyledVrmLookup
                className={classNames(limitWidth === 'true' && 'limited-width')}
                buttonText={<>Get an instant quote</>}
                formAction="/vehicles/add"
                targetBlank
                extraParams={{
                  itm_widget: itmWidget,
                  itm_article: itmArticle,
                  itm_wo: itmWo,
                  campaignId,
                  sku,
                }}
              />
            ) : (
              <a href={ctaButtonUrl} target="_top">
                <Button size="L" designType={DesignType.CTA_DARK} noIcon>
                  <ReactMarkdown
                    source={ctaButtonText}
                    renderers={{
                      // eslint-disable-next-line
                      paragraph: (pProps) => <React.Fragment {...pProps} />,
                    }}
                  />
                </Button>
              </a>
            )}
          </Col>
        </StyledRow>
      </WidgetContainer>
      {useVideo === 'true' && (
        <ResponsiveVideoWrapper displayFrom="md">
          <BgVideo
            src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1&loop=1&title=0&byline=0&portrait=0&background=1`}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            title="player"
            scrolling="no"
          />
          <script src="https://player.vimeo.com/api/player.js" />
        </ResponsiveVideoWrapper>
      )}
      {limitWidth === 'true' && bgImageUrl && <LimitWidthOverlay />}
      <ResponsiveBgImage
        displayFrom="sm"
        style={{
          backgroundImage: `url('${bgImageUrl}')`,
        }}
      />
    </BackgroundContainer>
  );
}
